import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './ButtonRounded.css';

const propTypes = {
    className: PropTypes.string,
    align: PropTypes.oneOf(['left', 'center', 'right']),
    label: PropTypes.string.isRequired,
    design: PropTypes.oneOf(['default', 'filled', 'warning']),
};

export class ButtonRounded extends React.Component {
    static defaultProps = {
        align: 'center',
        design: 'default',
    };

    render() {
        const { align, design, className, label, ...buttonProps } = this.props;

        return (
            <button
                {...buttonProps}
                className={classNames(s.buttonRounded, {
                    [s.left]: align === 'left',
                    [s.right]: align === 'right',
                    [s.filled]: design === 'filled',
                    [s.warning]: design === 'warning',
                })}
            >
                {this.props.label}
            </button>
        );
    }
}

ButtonRounded.propTypes = propTypes;



// WEBPACK FOOTER //
// ./app/web/src/components/actions/ButtonRounded.jsx